<p-confirmDialog key="pay" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Form-->
<div class="MainBorder">
	<div class="MainGrid2Col">
		<label>Student ID:</label>
		<label class="InfoText">{{ StudentID }}</label>

		<label>Student Name:</label>
		<label class="InfoText">{{ StudentName }}</label>

		<label>Balance:</label>
		<label class="InfoText">{{ CurrentBalanceDesc }}</label>

		<label>Comments:</label>
		<textarea class="TextArea" [(ngModel)]="Comments" rows="5"></textarea>

		<label>Apply Method:</label>
		<select class="form-control" name="MethodTypeID" [(ngModel)]="MethodTypeID" (ngModelChange)="onMethodTypeChange($event)">
			<option *ngFor="let r of lstMethodType" [ngValue]="r.ID">
				{{ r.Desc }}
			</option>
		</select>

		<!--Manually Pay Fines-->
		<label *ngIf="MethodTypeID == 1">Tender Type For Payments:</label>
		<select *ngIf="MethodTypeID == 1" class="form-control" name="TenderTypeID" [(ngModel)]="TenderTypeID">
			<option *ngFor="let r of lstTenderType" [ngValue]="r.TenderTypeID">
				{{ r.TenderTypeDesc }}
			</option>
		</select>

		<label *ngIf="MethodTypeID == 1">New Balance:</label>
		<label *ngIf="MethodTypeID == 1">{{ NewBalanceDesc }}</label>

		<label *ngIf="MethodTypeID == 1">Amount Paid:</label>
		<label *ngIf="MethodTypeID == 1">{{ TotalPaidDesc }}</label>

		<label *ngIf="MethodTypeID == 1">Amount Waived:</label>
		<label *ngIf="MethodTypeID == 1">{{ TotalWaivedDesc }}</label>

		<!--Automatically Pay or Waive Fines-->
		<label *ngIf="MethodTypeID == 2 || MethodTypeID == 3">Payment Order:</label>
		<select *ngIf="MethodTypeID == 2 || MethodTypeID == 3" class="form-control" name="OrderID" [(ngModel)]="OrderID">
			<option *ngFor="let r of lstOrder" [ngValue]="r.ID">
				{{ r.Desc }}
			</option>
		</select>

		<label *ngIf="MethodTypeID == 2">Tender Type:</label>
		<select *ngIf="MethodTypeID == 2" class="form-control" name="TenderTypeID" [(ngModel)]="TenderTypeID">
			<option *ngFor="let r of lstTenderType" [ngValue]="r.TenderTypeID">
				{{ r.TenderTypeDesc }}
			</option>
		</select>

		<label *ngIf="MethodTypeID == 2 || MethodTypeID == 3">Payment Amount:</label>
		<!-- <p-inputNumber *ngIf="MethodTypeID == 2 || MethodTypeID == 3" [min]="0" [max]="CurrentBalance" [(ngModel)]="PaidAmount" (ngModelChange)="onPaidAmountChange($event)" mode="currency" currency="USD" locale="en-US" step="0.01" [showButtons]="true"></p-inputNumber>  -->
		<input
			*ngIf="MethodTypeID == 2 || MethodTypeID == 3"
			class="form-control"
			type="number"
			[min]="0"
			[max]="CurrentBalance"
			step="0.01"
			[(ngModel)]="PaidAmount"
			(ngModelChange)="onPaidAmountChange($event)"
		/>

		<label *ngIf="MethodTypeID == 2 || MethodTypeID == 3">Updated Balance:</label>
		<label *ngIf="MethodTypeID == 2 || MethodTypeID == 3">{{ UpdatedBalanceDesc }}</label>
	</div>

	<!--Manual Table-->
	<div class="DataTable" [style.width.px]="popup_WidthInt" *ngIf="MethodTypeID == 1">
		<caass-manual-fine-table [SelectedPerson]="SelectedPerson" (ManualDataChange)="onManualDataChange()"> </caass-manual-fine-table>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
